import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconUploadCloud(rest) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
      />
    </Icon>
  )
}
